import { useState } from 'react'
import { useDispatch } from 'react-redux'

import { initialMylist } from '../slices/mylistSlice'
import useAxiosPrivate from './useAxiosPrivate'

const useSetMylist = () => {
	const [isSetting, setIsSetting] = useState(false)
	const axiosPrivate = useAxiosPrivate()
	const dispatch = useDispatch()

	const setMyList = async (menuId, isMylist) => {
		try {
			setIsSetting(true)
			const { data } = await axiosPrivate.post(
				`/POP_Homepage/SetMyList?menuId=${menuId}&isMylist=${isMylist}`
			)

			dispatch(initialMylist(data))
		} catch (err) {
			//
		} finally {
			setIsSetting(false)
		}
	}

	return { setMyList, isSetting }
}

export default useSetMylist
